// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import common from "@/utils/common.js";
import axios from "axios";

import "babel-polyfill";
Vue.config.productionTip = false;

// 大智慧云
window.dzhyun = new Dzhyun({
  address: process.env.Cloud_Service_API,
  dataType: "json",
  token: common.CloudToken()
});

// 大智慧微服务
window.dzhMicroToken = common.MicroToken();

Vue.prototype.$http = axios;

new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js